import React from "react";

export default function ContentLink({ item }) {
  const { url, text } = JSON.parse(item.data);
  return <a href={url}>{text}</a>;
}
